// extracted by mini-css-extract-plugin
export default {"pie_svg":"PieSVG_pie_svg__65frp","pie_svg_sector":"PieSVG_pie_svg_sector__UAJeW"};